import { useEffect, useState } from 'react';
import { useRender, useT } from '../context';
import { SmartLink } from '../components/common';

export function Footer() {
  const { site, menus } = useRender();
  const t = useT();
  if (!site) return null;
  const services = menus['footer-services'] ?? [];
  const copyright = site.copyrightText.replace('{year}', String(new Date().getFullYear()));

  return (
    <>
      <footer
        className="footer bg-style"
        style={site.footerBackground ? { backgroundImage: `url(${site.footerBackground.url})` } : undefined}
      >
        <div className="container">
          <div className="footer-upper">
            <div className="row">
              <div className="col-md-3 col-sm-6">
                <div className="footer-widget about-widget">
                  <h3 className="title">{t('contact')}</h3>
                  {site.footerLogo ? (
                    <figure className="image-box">
                      <img src={site.footerLogo.url} alt={site.footerLogo.alt || site.companyName} loading="lazy"
                        width={site.footerLogo.width ?? undefined} height={site.footerLogo.height ?? undefined} />
                    </figure>
                  ) : null}
                  <ul>
                    <li>
                      <SmartLink href={site.phoneHref} className="kfz-footer-light">
                        {t('phoneFooter')} : {site.phoneDisplay}
                      </SmartLink>
                    </li>
                    {site.contactPath ? (
                      <li>
                        <SmartLink href={site.contactPath} className="kfz-footer-light">
                          {t('contactForm')}
                        </SmartLink>
                      </li>
                    ) : null}
                  </ul>
                  {site.instagramUrl ? (
                    <div className="social-links">
                      <a href={site.instagramUrl} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                        <span className="fa fa-instagram" aria-hidden="true" />
                      </a>
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="col-md-3 col-sm-6">
                <div className="footer-widget quick-links">
                  <h3 className="title">{t('services')}</h3>
                  <ul>
                    {services.map((s) => (
                      <li key={s.id}>
                        <SmartLink href={s.href} newTab={s.newTab}>
                          {s.label}
                        </SmartLink>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="col-md-3 col-sm-6">
                <div className="footer-widget opening-hour">
                  <h3 className="title">{t('workingHours')}</h3>
                  <ul className="day-time">
                    <li>
                      <span>{site.openingDaysLabel} &nbsp;&nbsp;&nbsp;:</span>&nbsp;&nbsp;&nbsp; <span>{site.openingHoursShort}</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-3 col-sm-6">
                <div className="footer-widget experts-column">
                  <h3 className="title">{t('ourExpert')}</h3>
                  <ul>
                    {/* FIX: the legacy entry was a dead "#" link. */}
                    <li>
                      <a className="kfz-footer-expert">{site.expertName}</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <div className="footer-bottom text-center">
        <div className="copyright-text">{copyright}</div>
      </div>
    </>
  );
}

export function ScrollTop() {
  const t = useT();
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 200);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return (
    <button
      type="button"
      className={`scroll-top tran3s color2_bg${visible ? ' kfz-visible' : ''}`}
      aria-label={t('backToTop')}
      onClick={() => {
        const reduce = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
      }}
    >
      <span className="fa fa-angle-up" aria-hidden="true" />
    </button>
  );
}
